import { TranslationObject } from '@ngx-translate/core';
import { Source } from '@lib.core/entities/source/source';

export interface SourceDTO {
  titleShort: TranslationObject;
  title: TranslationObject;
  lastPublishedAt: string;
}

export function newSourceFromDto(sourceDTO: SourceDTO): [Source, Error | null] {
  if (sourceDTO.titleShort === undefined || sourceDTO.title === undefined || sourceDTO.lastPublishedAt === undefined) {
    return [new Source({}, {}, new Date()), new Error('Source is missing required fields')];
  }
  return [new Source(sourceDTO.titleShort, sourceDTO.title, new Date(sourceDTO.lastPublishedAt)), null];
}
